import { render, staticRenderFns } from "./ThankYouShopify.vue?vue&type=template&id=6cb7debe&scoped=true&"
import script from "./ThankYouShopify.vue?vue&type=script&lang=js&"
export * from "./ThankYouShopify.vue?vue&type=script&lang=js&"
import style0 from "./ThankYouShopify.vue?vue&type=style&index=0&id=6cb7debe&scoped=true&lang=scss&"
import style1 from "./ThankYouShopify.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb7debe",
  null
  
)

component.options.__file = "ThankYouShopify.vue"
export default component.exports